export default __webpack_public_path__ + "static/media/linkIcon.14055c09.svg";